"use client"

import { useState } from "react"
import { signIn } from "next-auth/react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { KeyRound, Loader2 } from "lucide-react"

export function SignIn() {
    const [password, setPassword] = useState("")
    const [error, setError] = useState("")
    const [isLoading, setIsLoading] = useState(false)

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setError("")
        setIsLoading(true)

        try {
            const result = await signIn("password", {
                password,
                redirect: false,
            })

            if (result?.error) {
                setError("Invalid password")
            } else if (result?.ok) {
                // Refresh the page to show authenticated content
                window.location.reload()
            }
        } catch {
            setError("Authentication failed")
        } finally {
            setIsLoading(false)
        }
    }

    const hasPassword = password.trim().length > 0

    return (
        <form onSubmit={handleSubmit} className="flex flex-col gap-3 w-full max-w-xs">
            <div className="relative">
                <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                    type="password"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
                    className="pl-9"
                    disabled={isLoading}
                    autoFocus
                    autoComplete="current-password"
                />
            </div>
            {error && (
                <p className="text-sm text-destructive">{error}</p>
            )}
            <Button type="submit" disabled={isLoading || !hasPassword}>
                {isLoading ? (
                    <>
                        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                        Signing in...
                    </>
                ) : (
                    "Sign In"
                )}
            </Button>
        </form>
    )
}
